

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";

const prodSetUpDataAtom = atom({key:'productionSetupAtomData', default:{production_item_info:[], finished_item_info:[], required_item_info:[]}});


export  const SetProdSetUpAtomData = () => useSetRecoilState(prodSetUpDataAtom);
export  const GetProdSetUpAtomData = () => useRecoilValue(prodSetUpDataAtom);
export const ResetProdSetUpAtomData = ()=> useResetRecoilState(prodSetUpDataAtom);


